<template>
    <div class="row mb-3">
      <div class="col-12">
        <div class="d-flex justify-content-between align-items-center">
          <p class="lead m-0">Frentes de Trabalho</p>
        </div>
      </div>
    </div>
    <div class="row">
        <div class="col-12 mb-3 text-right">
        <button v-if="authenticated_user" class="btn btn-primary" @click="openForm()">Criar Frente de Trabalho</button>
        </div>
    </div>
    <div class="row">
      <div class="col-12">
        <DataTable
          :value="work_fronts"
          :lazy="true"
          :paginator="true"
          :rows="per_page"
          :rows-per-page-options="[10, 25, 50]"
          :total-records="total_work_fronts"
          :loading="loading"
          :row-hover="true"
          @page="onPage($event)"
          @sort="onSort($event)"
          ref="datatable"
          data-key="id"
          class="p-datatable-gridlines p-datatable-sm"
        >
          <template #empty> Nenhuma frente de trabalho</template>
          <template #loading> Carregando</template>
          <ColumnGroup type="header">
            <Row>
              <Column class="text-center bg-primary text-light" header="ID" header-class="bg-light" />
              <Column class="text-center bg-primary text-light" header="Nome" />
              <Column class="text-center bg-primary text-light" header="Responsável" />
              <Column class="text-center bg-primary text-light" header="Responsável Terceiro" />
              <Column class="text-center bg-primary text-light" header="Supervisor Adequação" />
              <Column class="text-center bg-primary text-light" header="Membros" />
              <Column class="text-center bg-primary text-light" header="Setores" />
              <Column class="text-center bg-primary text-light" header="Graus de Risco NR-12" />
              <Column class="text-center bg-primary text-light" header="Graus de Risco NR-33" />
              <Column class="text-center bg-primary text-light" header="Ações" header-class="bg-light" />
              <Column class="text-center bg-primary text-light" header="Prioridade" />
            </Row>
          </ColumnGroup>
          <Column class="text-center" field="id"></Column>
          <Column class="text-center" field="name"></Column>
          <Column class="text-center">
            <template #body="{ data }">
              {{ data.responsible?.name || '-' }}
            </template>
          </Column>
          <Column class="text-center">
            <template #body="{ data }">
              {{ data.responsible_third_party?.name || '-' }}
            </template>
          </Column>
          <Column class="text-center">
            <template #body="{ data }">
              {{ data.adequacy_supervisor?.name || '-' }}
            </template>
          </Column>
          <Column class="text-center">
            <template #body="{ data }">
              <div
                class="mt-1 mb-1"
                v-for="member in data.members"
                v-bind:key="member.id"
              >
                {{ member?.name || '-' }}
              </div>
              <span v-if="data.members.length == 0">-</span>
            </template>
          </Column>
          <Column class="text-center">
            <template #body="{ data }">
              <div
                class="mt-2"
                v-for="wfcs in data.sectors"
                v-bind:key="wfcs.id"
              >
                <span class="tag text-light bg-primary">{{ wfcs.name }}</span>
              </div>
              <span v-if="data.sectors.length == 0">-</span>
            </template>
          </Column>
          <Column class="text-center">
            <template #body="{ data }">
              <div
                class="mt-2"
                v-for="wfnmdr in data.degreesNR12"
                v-bind:key="wfnmdr.id"
              >
                <span
                  class="tag"
                  v-if="wfnmdr.regulatory_standard == 'nr12'"
                  :class="{ unacceptable: wfnmdr.magnitude === 8 }"
                  :style="`background-color: ${getHrnLevelColor(
                    wfnmdr.magnitude,
                  )}`"
                >
                  {{ wfnmdr.name }}
                </span>
              </div>
              <span v-if="data.degreesNR12.length == 0">-</span>
            </template>
          </Column>
          <Column class="text-center">
            <template #body="{ data }">
              <div
                class="mt-2"
                v-for="wfnmdr in data.degreesNR33"
                v-bind:key="wfnmdr.id"
              >
                <span
                  class="tag"
                  v-if="wfnmdr.regulatory_standard == 'nr33'"
                  :style="`background-color: ${getRiskColor(
                    wfnmdr.magnitude,
                  )}`"
                >
                  {{ wfnmdr.name }}
                </span>
              </div>
              <span v-if="data.degreesNR33.length == 0">-</span>
            </template>
          </Column>
          <Column class="text-center">
            <template #body="slotProps">
              <button
                class="btn btn-link"
                v-tooltip="'Clique para editar'"
                v-if="authenticated_user"
                @click="editWorkFront(slotProps.index)"
              >
                <font-awesome-icon
                  :icon="['fas', 'pen-alt']" style="cursor: pointer"
                ></font-awesome-icon>
              </button>
              <button
                class="btn btn-link"
                v-tooltip="'Clique para excluir'"
                v-if="authenticated_user"
                @click="deleteWorkFront(slotProps.index)"
              >
                <font-awesome-icon
                  :icon="['fas', 'trash-alt']" style="cursor: pointer"
                ></font-awesome-icon>
              </button>
            </template>
          </Column>
          <Column class="text-center">
            <template #body="slotProps">
              <button
                class="btn btn-link"
                v-tooltip="'Subir prioridade'"
                v-if="authenticated_user"
                @click="upPriority(slotProps.index)"
              >
                <font-awesome-icon
                  :icon="['fas', 'chevron-up']" style="cursor: pointer"
                ></font-awesome-icon>
              </button>
              <button
                class="btn btn-link"
                v-tooltip="'Diminuir prioridade'"
                v-if="authenticated_user"
                @click="downPriority(slotProps.index)"
              >
                <font-awesome-icon
                  :icon="['fas', 'chevron-down']" style="cursor: pointer"
                ></font-awesome-icon>
              </button>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
</template>

<script>
  import { computed, ref } from 'vue'
  import { useStore } from 'vuex'
  import Column from 'primevue/column';
  import ColumnGroup from 'primevue/columngroup';
  import DataTable from 'primevue/datatable';
  import Row from 'primevue/row';
  import useSwal from '@/modules/Swal.js'
  import useWorkFront from '@/modules/WorkFront.js'
  import { useRouter } from 'vue-router';
  import useHrn from '@/modules/Hrn.js'
  import useDegreeOfRisk from '@/modules/DegreeOfRiskUtil.js'

  export default {
    components: {
      Column,
      ColumnGroup,
      DataTable,
      Row
    },
    setup() {
      const store = useStore()
      const selected_company = computed(() => store.getters.selected_company)
      const authenticated_user = computed(() => store.getters.authenticated_user.work_front_manager)
      const datatable = ref(null)
      const router = useRouter()
      const {
          work_fronts,
          total_work_fronts,
          loading,
          listWorkFront,
          destroyWorkFront,
          storeWorkFront
      } = useWorkFront()
      const { showConfirmDeletionSwal } = useSwal()
      const { getHrnLevelColor } = useHrn()
      const { getRiskColor } = useDegreeOfRisk()

      return {
          datatable,
          loading,
          work_fronts,
          destroyWorkFront,
          storeWorkFront,
          listWorkFront,
          total_work_fronts,
          showConfirmDeletionSwal,
          router,
          selected_company,
          authenticated_user,
          getHrnLevelColor,
          getRiskColor
      }
    },
    data() {
      return {
        page: 1,
        per_page: 10,
      }
    },
    methods: {
      loadWorkFronts() {
        this.listWorkFront(this.selected_company.id, this.page, this.per_page)
      },

      onPage(event) {
        this.page = event.page + 1
        this.per_page = event.rows
        this.loadWorkFronts()
      },

      editWorkFront(item) {
        const work_front = this.work_fronts[item]

        this.$router.push({
          name: 'work-front-edit',
          params: { id: work_front.id }
        })
      },

      deleteWorkFront(item) {
        const work_front = this.work_fronts[item]

        this.showConfirmDeletionSwal()
          .then(response => {
            if (response.isConfirmed) {
              this.destroyWorkFront(work_front).then(data => {
                this.loadWorkFronts()
              })
            }
          })
          .catch(error => {
            console.log(error)
          })
      },

      openForm() {
          this.router.push('/work-front/create');
      },

      upPriority(item) {
        const work_front = this.work_fronts[item]

        this.axios.put(`/api/work-front/upPriority/${work_front.id}`)
          .then(({data}) => {
            this.loadWorkFronts()
            return data.data
          })
          .catch(error => {
            console.log(error)
            return null
          })
      },

      downPriority(item) {
        const work_front = this.work_fronts[item]

        this.axios.put(`/api/work-front/downPriority/${work_front.id}`)
          .then(({data}) => {
            this.loadWorkFronts()
            return data.data
          })
          .catch(error => {
            console.log(error)
            return null
          })
      },
    },
    mounted() {
      this.loadWorkFronts()
    }
  }
</script>

<style lang="scss" scoped>
  .tag {
    padding: 2px 10px;
    border-radius: 15px;
  }
</style>
